import React, { Component } from 'react';
import './App.css';
import AppHome from './app-home/app.home.js';

class App extends Component {
    render() {
        return (
            <div>
                <AppHome/>
            </div>
        );
    }
}

export default App;
